import { gql } from '@apollo/client';

export default gql`
  mutation addPreferencesDistrict($input: DistrictRefInput!) {
    addBuyerPreferencesDistrict(input: $input)
  }
`;
